
<ngx-spinner bdColor="rgba(0, 0, 0, 0.9)" size="medium" color="#fff" type="ball-pulse-sync" [fullScreen]="true"><p
  style="color: white"> Lütfen Bekleyiniz. </p></ngx-spinner>
<router-outlet></router-outlet>
